import { useState, useEffect } from 'react';

export function useLocalState(key, initialValue) {
  const getStoredValue = () => {
    const storedValue = localStorage.getItem(key);
    let value;
    if (storedValue != null) {
      try {
        value = JSON.parse(storedValue);
      } catch (e) {
        console.warn('Failed to parse localStorage value for key:', key, e);
      }
    }
    if (typeof initialValue === 'function') {
      return initialValue(value);
    } else if (value) {
      return value;
    }
    return initialValue;
  };

  const [value, setValue] = useState(getStoredValue);

  useEffect(() => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.warn('Failed to save value to localStorage for key:', key, e);
    }
  }, [key, value]);

  return [value, setValue];
}
